import React from "react"
import AlertDropDown from "./AlertDropDown"
import BetaBanner from "./BetaBanner"
import { Outlet } from "react-router-dom"
const GlobalWrapper = () => {
  return (
    <>
      <BetaBanner />
      <AlertDropDown />
      <Outlet />
    </>
  )
}

export default GlobalWrapper
